export const useGeneralAgree = () => useState('agree', () => false)

// view diaries
export const useModalsDiary = () => useState('useModalsDiary', () => null)
export const useModalsDiaryShow = () => useState('useModalsDiaryShow', () => false)
export const useModalsDiaryModalRef = () => useState('useModalsDiaryModalRef', () => false)

// view shorts
export const useModalsShort = () => useState('useModalsShort', () => null)
export const useModalsShortShow = () => useState('useModalsShortShow', () => false)
export const useModalsShortModalRef = () => useState('useModalsShortModalRef', () => false)
export const useModalsShortModalList = () => useState('useModalsShortModalList', () => false)
export const useModalsShortModalListIndex = () => useState('useModalsShortModalListIndex', () => 0)
export const useModalsShortHidePlayerFunc = () => useState('useModalsShortHidePlayerFunc', () => () => {})
export const useModalsShortLoadMoreFunc = () => useState('useModalsShortLoadMoreFunc', () => () => {})

// edit shorts

export const useModalsShortEditShow = () => useState('useModalsShortEditShow', () => false)
export const useModalsShortEditId = () => useState('useModalsShortEditId', () => null)



// Global in‑memory cache (unique key to avoid clashing with other states)
export const useCache = () => useState('appCache', () => ({} as Record<string, any>))

const MAX_CACHE_ENTRIES = 500; // Prevent unlimited growth

export function useCacheData() {
    function getCache(key) {
        const cache = useCache()
        if (cache.value[key]) {
            return cache.value[key]
        } else {
            return null
            const cacheValue = useState(key, () => null)
            cache.value[key] = cacheValue
            return cacheValue
        }
    }
    function setCache(key, value) {
        const cache = useCache()
        
        // Prevent unlimited cache growth
        if (Object.keys(cache.value).length >= MAX_CACHE_ENTRIES && !cache.value[key]) {
            // Remove oldest entry (first key)
            const oldestKey = Object.keys(cache.value)[0];
            delete cache.value[oldestKey];
        }
        
        if (cache.value[key]) {
            cache.value[key].value = value
        } else {
            const cacheValue = useState(key, () => value)
            cache.value[key] = cacheValue
        }
    }
    
    function clearCache() {
        const cache = useCache()
        cache.value = {}
    }
    
  return {
    getCache,
    setCache,
    clearCache,
  }
}